// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__GJGQN","noInteraction":"EventWrapper_noInteraction__IRAZD","pointerPassthrough":"EventWrapper_pointerPassthrough__1Myrf"};